
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n        ', badge, '\n      ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI3(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', { 'className': 'cm_product-item grid-item__link card card-product' }, !this.on_sale ? _createElement('div', {
                    'className': 'card-product-badges',
                    'key': '66'
                }, _createElement('div', { 'className': 'card-badge' }, _createElement('span', { 'className': 'badge badge-sale' }, ' Sale '))) : null, _createElement('a', {
                    'href': this.url,
                    'className': 'cm_product-item__image-container card-media'
                }, _createElement('img', {
                    'className': 'cm_product-item__image' + (this.image2 ? ' cm_product-item__image_primary' : ''),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'cm_product-item__image cm_product-item__image_secondary',
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '542'
                }) : null, this._badges ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_badge-container cm_badge-right',
                        'key': '772'
                    },
                    _map(this._badges, repeatBadge1.bind(this))
                ]) : null), _createElement('div', { 'className': 'card-info-wrap' }, _createElement('div', { 'className': 'card-info' }, this.vendor && this.vendor_url ? _createElement('a', mergeProps({
                    'href': this.vendor_url,
                    'className': 'card-eyebrow',
                    'key': '1072'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null, _createElement('h3', { 'className': 'card-heading typography-body' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'js-product-link'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', { 'className': 'cm_product-item__sku-container' }, this.sku ? _createElement('div', {
                    'className': 'cm_product-item__sku',
                    'key': '1596'
                }, _createElement('span', { 'className': 'sku-title' }, 'SKU: '), _createElement('span', mergeProps({ 'className': 'sku-value' }, { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } }))) : null), this.out_of_stock ? _createElement('div', {
                    'className': 'badge-stock badge-stock-out',
                    'key': '1886'
                }, _createElement('span', { 'className': 'badge-stock-icon' }), '\n        ', _translate(`product_out_of_stock`), '\n      ') : null, !this.out_of_stock ? _createElement('div', {
                    'className': 'badge-stock badge-stock-in',
                    'key': '2060'
                }, _createElement('span', { 'className': 'badge-stock-icon' }), '\n        In stock\n      ') : null), _createElement('div', { 'className': 'card-footer' }, _createElement('div', { 'className': 'price' }, this.on_sale ? _createElement('div', {
                    'className': 'price price-sold-out price-on-sale',
                    'key': '2274'
                }, _createElement('div', { 'className': 'price-container' }, _createElement('div', { 'className': 'price-discount' }, _createElement('div', { 'className': 'price-item price-item-regular' }, _createElement('s', {}, this.formatPrice(this.compare_at_price)))), _createElement('div', { 'className': 'price-item price-item-sale price-item-last' }, this.formatPrice(this.price)))) : null, !this.on_sale ? _createElement('div', {
                    'className': 'price-container',
                    'key': '2733'
                }, _createElement('div', { 'className': 'price-regular' }, _createElement('span', { 'className': 'price-item price-item-regular' }, ' ', this.formatPrice(this.price)))) : null), _createElement('div', { 'className': 'card-floating-footer' }, _createElement('div', { 'className': 'card-product-actions' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'product-actions-add-to-cart',
                    'id': this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'cm_button cm_button__secondary',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '31901'
                    }, '\n                ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n              ')] : null, this.variant_ids.length === 1 ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '35081'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '35083'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '35085'
                    }) : null,
                    _createElement('button', {
                        'className': 'button button-secondary button-add-to-cart button-solid',
                        'type': 'submit',
                        'data-form-id': this.id,
                        'disabled': this.out_of_stock,
                        'key': '35087'
                    }, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [
                        _translate(`product_add_to_cart`),
                        this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : ''
                    ] : null)
                ] : null)))), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '45030'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI3.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '4904'
                }) : null));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []